const getFilterGroups = queryOptions => filter => {
  return filter.groups.map(group => {
    if (Object.keys(queryOptions).includes(group.key)) {
      const items = group.items.map(item => {
        if (Object.values(queryOptions).includes(item.value)) {
          return { ...item, checked: true };
        }
        return { ...item };
      });
      return { ...group, items };
    }
    return { ...group };
  });
};

export default getFilterGroups;
